import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { NotificationOutput } from '../model/notification.output';

export interface AcceptMeetingParams {
	readonly id: string;
}

@Injectable({ providedIn: 'root' })
export class AcceptMeetingApiMutation extends ApiMutation<
	NotificationOutput,
	AcceptMeetingParams
> {
	client = 'messaging';
	document = gql`
		mutation AcceptMeeting($id: UUID!) {
			acceptMeeting(id: $id) {
				id
				type
				taskId
				documentId
				orgModuleId
				sourceUserId
				targetUserId
				contactsName
				updateTimestamp
				creationDateTime
				meeting {
					coachId
					endDate
					startDate
				}
			}
		}
	`;
	method = 'acceptMeeting';
}
